import * as React from 'react';
import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {}
const Radio = ({ id, checked = false, onChange, value, name }: RadioProps) => {
  return (
    <RadioInput
      id={id}
      type={'radio'}
      checked={checked}
      onChange={onChange}
      value={value}
      name={name}
    />
  );
};

export default Radio;

const RadioInput = styled.input<{
  checked: boolean;
}>`
  width: 20px;
  height: 20px;
`;
